import { Component } from '@angular/core';
import { ModalService } from '@lsq-frontend/common-ui';
import { BehaviorSubject } from 'rxjs';
import {
    GetSupplierAgreementStatusRequest,
    GetSupplierAgreementStatusService
} from '@lsq-frontend/remote-services/all-java/financing-mk2-services/operations/admin-supplier-agreement/get-supplier-agreement-status';

@Component({
    selector: 'toggle-supplier-eligibility-modal',
    styleUrls: ['./toggle-supplier-eligibility-modal.component.scss'],
    template: `
        <lsq-circle-loader *ngIf="loading$ | async"></lsq-circle-loader>
        <div *ngIf="!(loading$ | async)" class="modal-body toggle-supplier-eligibility-modal">
            <p class="bottom-margin body">{{ !eligible ? ELIGIBLE_BODY : INELIGIBLE_BODY }}</p>
            <data-card>
                <div class="data-item">
                    <div class="data-header p label">Buyer:</div>
                    <div class="data-value p body">{{ buyerName }}</div>
                </div>
                <div class="data-item">
                    <div class="data-header p label">Supplier:</div>
                    <div class="data-value p body">{{ supplierPreferredName }}</div>
                </div>
            </data-card>
            <div class="warning" *ngIf="showWarning && !eligible">
                <div class="control-row">
                    <lsq-checkbox (change)="warningCheckUpdated($event)"></lsq-checkbox>
                    <div [style.width]="'100%'" [style.paddingRight]="'1rem'" class="p body">
                        Alternative Supplier Agreement is currently Enabled. You are attempting to
                        enable Early Payments Eligibility before a supplier agreement has been
                        completed. Are you sure you wish to proceed?
                    </div>
                </div>
            </div>
        </div>
    `
})
export class ToggleSupplierEligibilityModalComponent {
    public INELIGIBLE_BODY =
        'Turning this off will remove the supplier ability to make early payments within FastTrack. Do not proceed unless you have verified a need for this change for the supplier listed below.';
    public ELIGIBLE_BODY =
        'By enabling this, you acknowledge that all of the provided information for this supplier has been reviewed and verified. This allows the ability to request early payments for the following supplier(s):';

    public eligible: boolean;
    public supplierPreferredName: string;
    public buyerName: string;
    public showWarning = false;
    public okButtonIsDisabled$?: BehaviorSubject<boolean>;
    public loading$ = new BehaviorSubject<boolean>(true);

    constructor(
        private _modalService: ModalService,
        private _getSupplierAgreementStatusService: GetSupplierAgreementStatusService
    ) {
        const modalData = this._modalService.modal.data;

        this.okButtonIsDisabled$ = modalData.okButtonIsDisabled$;
        this.eligible = modalData.supplierRelationship.eligible;
        this.supplierPreferredName = modalData.supplierRelationship.supplierPreferredName;
        this.buyerName = modalData.supplierRelationship.buyerPreferredName;

        if (!this.eligible) {
            this.getAgreementStatus(modalData.supplierRelationship.relationshipKey);
        } else {
            this.okButtonIsDisabled$.next(false);
            this.loading$.next(false);
        }
    }

    private async getAgreementStatus(relationshipKey: string): Promise<void> {
        const supplierAgreementStatus = await this._getSupplierAgreementStatusService.executeOnce(
            new GetSupplierAgreementStatusRequest({
                relationshipKey: relationshipKey
            })
        );

        this.showWarning =
            supplierAgreementStatus.usingAlternateSupplierAgreement &&
            !supplierAgreementStatus.submittedByAdmin &&
            !supplierAgreementStatus.supplierAgreementSignedDate;

        this.okButtonIsDisabled$.next(this.showWarning);
        this.loading$.next(false);
    }

    public warningCheckUpdated(event: any): void {
        this.okButtonIsDisabled$.next(!event.target.checked);
    }
}
